import { PriceOverrideStatus } from "@classes-service-types/index";

export const ALL_PRICE_OVERRIDE_STATUSES_SORTED = Object.values(PriceOverrideStatus).sort();
